module.exports = __webpack_public_path__ + "static/14-7ca8bd9b978ae27f7882b5da4a76e973.jpg";